export default "__VITE_ASSET__CVX1woJ4__"